export const consortium = [
    {
        name: 'ACRI-ST',
        link: 'https://www.acri-st.fr',
        image: require('./images/acri-st.png'),
        description:`
        ACRI-ST is an independent SME working in the Space sector, specializing in the prototyping and engineering of EO data processors, 
        data quality check systems, end-to-end and sensors’ simulations, calibration and validation, data processing, archiving and 
        distribution. The company encompasses both development and service operation activities.`
    },
    {
        name: 'Adwaiseo',
        link: 'https://www.adwaiseo.eu/en/home/',
        image: require('./images/adwaiseo.png'),
        description:`
        adwäisEO (SME) is the Luxembourg entity of the ACRI group in charge of the development of space data IT services. adwäisEO is 
        responsible for Cloud integration and archive delivery in the S3PS project.
        `
    },
]